import { render, staticRenderFns } from "./pendings.vue?vue&type=template&id=20ba717e"
import script from "./pendings.vue?vue&type=script&lang=js"
export * from "./pendings.vue?vue&type=script&lang=js"
import style0 from "./pendings.vue?vue&type=style&index=0&id=20ba717e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports